const divForgotPassword = {
  text: 'Link enviado a su email',
  text1: 'Email enviado a'
};

export default divForgotPassword;
